module.exports = __webpack_public_path__ + "static/media/002-internet.3f4e01f5.svg";